import {OptimizationTaskPrecalculation} from "./optimization-task-precalculation";

export class OptimizationTaskCalculationResult {
  hasErrors: boolean;
  errorMessage: string|null;
  unavailableCalculation: boolean;
  calculation: OptimizationTaskPrecalculation;
}